import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { WaterBodyDAO } from '../../../../../core/services/dao/waterBodyDAO';
import { WaterBody } from 'anchor-shared/lib/model/entity/waterBody';
import { ContainsSubscriptions } from '../../../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../../../../../core/pure-functions/rx-helper';

@Component({
  selector: 'app-availability',
  templateUrl: './availability.component.html',
  styleUrls: ['./availability.component.scss'],
})
export class AvailabilityComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  subs: Subscription[] = [];
  @Input() title: string;

  @Input() modelWaterBodies: WaterBody[];

  @Input() newCaptain: boolean;

  @Input() adminAccess: boolean;

  @Output() onCancelled = new EventEmitter<boolean>();
  @Output() onSubmitted = new EventEmitter<any>();

  model: any = {
    waterBodies: [],
  };
  waterBodies: WaterBody[];

  constructor(private waterBodyDAO: WaterBodyDAO) {}

  ngOnInit() {
    if (!this.newCaptain) {
      this.model.waterBodies = this.modelWaterBodies;
    }
    const waterBodiesSub = this.waterBodyDAO.get().subscribe((wb) => {
      this.waterBodies = wb;
    });
    this.subs.push(waterBodiesSub);
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  onSubmit() {
    this.onSubmitted.emit(this.model.waterBodies);
  }

  cancel() {
    console.log('cancel');
  }
}
